import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable, BehaviorSubject, Subject} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {Vendor} from '../../pages/user-management/vendor/vendor.model';

export interface VendorRequestParam {
    id: number;
    name: string;
    partyTypeId: number;
    createdOn: string;
    statusId: number;
    status: string;

}

@Injectable()
export class VendorService {

    constructor(private apiRequest: ApiRequestService,
                private appConfig: AppConfig) {
    }
    // fetch All Vendor
    getAllVendor(pageNumber: any, limit: any): Observable<any> {
        const me = this;
        const vendorListSubject = new Subject<any>(); // Will use this subject to emit data that we want
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', limit);
        me.apiRequest.get(this.appConfig.vendor_url + '/2/parties', params).subscribe(jsonResp => {
            const items = jsonResp.data.map(function (v) {
                return Object.assign({}, v, {
                    id: `${v.id}`,
                    name: `${v.name}`,
                    partyTypeId: `${v.partyTypeId}`,
                    statusId: `${v.statusId}`,
                    status: `${v.status}`,
                });
            });

            const coldObj = Object.assign({}, jsonResp, {
                data: items
            });
            vendorListSubject.next(coldObj); // incidentList is a Subject and emits an event thats being listened to by the components
        });
        return vendorListSubject;
    }
    // save parties
    save(vendor: Vendor): Observable<any> {
        const me = this;

        const bodyData: VendorRequestParam = <VendorRequestParam> {
            'partyTypeId': 2,
            'name': vendor.name

        };

        const vendorDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.post(this.appConfig.parties_url, bodyData)
            .subscribe(jsonResp => {
                    let vendorInfoReturn: VendorRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const vendor: Vendor = jsonResp.data[0];

                        vendorInfoReturn = <VendorRequestParam>{
                            'partyTypeId': 2,
                            'name': vendor.name
                        };

                    } else {
                        console.log('added:----:' + jsonResp.message);
                    }
                    vendorDataSubject.next(vendorInfoReturn);
                },
                err => {
                    console.log('added err:----:' + err);
                });

        return vendorDataSubject;
    }
    // update parties
    update(vendor: Vendor, id: number): Observable<any> {
        const me = this;

        const bodyData = {
            'id': vendor.id,
            'name': vendor.name
        };

        const vendorDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.put(this.appConfig.parties_url + '/' + id, bodyData)
            .subscribe(jsonResp => {
                    let vendorInfoReturn: VendorRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const cc: Vendor = jsonResp.data[0];
                        vendorInfoReturn =  <VendorRequestParam> {
                            'id': cc.id,
                            'name': cc.name,
                        };

                    } else {
                        console.log('updated :----:' + jsonResp.message);
                    }
                    vendorDataSubject.next(vendorInfoReturn);
                },
                err => {
                    console.log('update  err:----:' + err);
                });

        return vendorDataSubject;
    }

    deleteVendor(id: number): Observable<any> {
        const me = this;
        return me.apiRequest.delete(this.appConfig.parties_url + '/' + id);
    }

    getAllPartiesDD(pageNumber: any, limit: any) {
        const me = this;
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', limit);
        return me.apiRequest.get(this.appConfig.parties_dd_url, params);
    }
}
